<template>
  <zm-dialog
    :model-value="visible"
    class="opc-coupon-terms-condition"
    width="520px"
    :title="$t('billing.coupon.terms_and_conditions')"
    @close="handleCancel"
  >
    <zm-banner
      v-if="warningTip"
      type="warning"
      class="alert-warning-banner"
      :show-close="false"
      style="margin-bottom: 16px;"
      :content="warningTip"
    />
    <div v-html="termsCondition" class="opc-coupon-terms-condition__body"></div>
    <template #footer>
      <zm-button data-testid="checkout-button-390" type="primary" @click="onAccept">
        {{ $t('billing.common.accept') }}
      </zm-button>
      <zm-button data-testid="checkout-button-391" @click="onReject">{{ $t('billing.common.reject') }}</zm-button>
    </template>
  </zm-dialog>
</template>
<script>
import _ from 'lodash';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { mapGetters } from 'vuex';
import { ConsumptionCategoryList } from '@/common/constants';
import { subscriptionLevelActionEnum } from '@/views/config/coupon/helper/constant';
import { isEmptyVal } from '@/utils';

export default {
  mixins: [ConfirmComponent],
  data() {
    return {
      termsCondition: '',
    };
  },
  computed: {
    ...mapGetters(['boughtPlans', 'couponState']),
    consumptionPlanList() {
      return _.filter(this.boughtPlans, p => _.includes(ConsumptionCategoryList, p.plan_code));
    },
    hasConsumptionPlan() {
      return this.consumptionPlanList?.length > 0;
    },
    warningTip() {
      // one-time zs/ze ppa consumption plan
      if (this.hasConsumptionPlan) {
        const existActiveConsumptionPlan = _.some(this.consumptionPlanList, (p) => !isEmptyVal(p?.creditPlans));
        const isReplaceSubscription = this.couponState?.subscriptionLevelAction === subscriptionLevelActionEnum.replaceSubscription;

        if (existActiveConsumptionPlan && isReplaceSubscription) {
      return this.$t('billing.events.ppa_terms_condition_imme');
        }
      }

      return null;
    },
  },
  methods: {
    onAccept() {
      this.handleSure();
    },
    onReject() {
      this.handleCancel();
    },
  },
};
</script>
<style lang="scss">
.zbo-banner {
  &.alert-warning-banner {
    padding: 12px 8px;

    &__title {
      display: flex;

      p {
        margin-bottom: 0;
        color: var(--zoom-color-text-strong-warning, #B36200);
        font-size: 14px;
        font-weight: 450;
      }
    }

    .zbo-alert__content .zbo-button--icon:hover {
      background-color: transparent;
    }
  }
}

.opc-coupon-terms-condition {
  &__body {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 5px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    line-height: 21px;

    ul {
      margin: 8px 0px;
      padding-left: 25px;
      list-style: unset;

      li {
        padding: 2px 0px;
      }
    }

    &::-webkit-scrollbar {
      width: 7px;
      cursor: pointer;
      background: #f8f8f8;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      opacity: .4;
      border-radius: 7px;
    }

    &::-webkit-scrollbar-track {
      background-color: #f8f8f8;
    }

    .threshold-coupon-terms-wrapper {
      line-height: 24px;
      font-size: 14px;

      .threshold-coupon-cycle-row {
        margin: 15px 0;

        .threshold-coupon-product-name {
          margin: 0;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
